'use strict';
import Global from '@/scripts/Global'
import SessionManager from '@/Manager/Session.manager'
import { Logging } from '@/scripts/Logging'
import config from '@/scripts/config'
import VueSignals from '@/scripts/VueSignals';
import {serverBus} from "@/main";
import KeyboardManager from "@/Manager/keyboard.manager";

let instance = null;
let reconnect_attempt = -1
let logout = false
let socket_closed = false
let session_id = Global.getSessionID()
let block_reconnecting = false
let MAX_CONNECTION_ATTEMPTS = 24; // 2 minutes of short heart beats, change to long heart beats
let SHORT_HEART_BEATS = 1000 * 5 * 1; // Every 5s
let LONG_HEART_BEATS = 1000 * 60 * 2; // Every 2min
export default class Socket {
  constructor(){
  }
  static init(){

      try {
          instance = new WebSocket(Global.GetWSS())
          instance.onclose = function(event, reason) {
              // Socket.heartbeat()
              socket_closed = true
              if(typeof sessionStorage.getItem('session_id_invalid') != 'undefined' && !sessionStorage.getItem('session_id_invalid')){
                  if(!logout){
                      Logging.Info("Reconnecting....")
                      // instance.close()

                      /*connection lost*/
                      Global.globalValue(VueSignals.CONNECTION_LOST, true)
                  }
              }
              Logging.Warn("[ connection closed ]   ",event);
              if(event.code == config.SOCKET_CLOSED_ERROR_CODE)  {
                  block_reconnecting = true;
                  logout = true;
                  Global.logout();
              }
              console.error('WebSocket closed');
              console.error(event);
              console.error(reason);
          }

          instance.onerror = function (event) {
              console.error('WebSocket error');
              console.error(event);
          }

          instance.onmessage = function(e) {
              let message_data  = JSON.parse(e.data);
              Global.globalValue(message_data.event,message_data);
              Logging.Info("[" + message_data.event+ "]   ",message_data)
          }
      } catch (error) {
          console.log('error stating the websocket', error);
      }
  }

  static push(data){
    if(instance != null && instance.readyState === instance.OPEN){
      instance.send(JSON.stringify(data));
    }else {
      Global.globalValue(VueSignals.CONNECTION_LOST, true)
      Socket.init()
    }
  }

  static close(){
    if(instance != null){
      instance.close()
    }
    logout = true
  }
  static Notify(data){
    instance.onopen = function(e){
      Logging.Warn("[connection established]   ",data)
      socket_closed = false
      Global.globalValue(VueSignals.CONNECTION_LOST, false)
      if(typeof data.session_id != 'undefined' && data.session_id != ''){
        session_id = data.session_id
      }
      Socket.push(data)
    };

      serverBus.$on(VueSignals.CONNECT_SUCCESS, (modalStatus) => {
          let post = {
              "event": VueSignals.SOCKET_USER_STATUS_CHANGED,
              "data": {
                  'status': SessionManager.getLoggedInUser().status_mode,
              },
              "broadcast": {
                  "user_ids":SessionManager.getBroadCastUsersIds()
              },
          }
          Logging.Info("[" + post.event+ "]   ",post.data)
          try {
              Socket.push(post)
          }catch(err){
              Logging.Error(err)
          }
      });
  }

  static reconnectAttempt() {
      if(!navigator.onLine || socket_closed){
        reconnect_attempt++
        Global.globalValue(VueSignals.CONNECTION_LOST, true)
        Global.globalValue(VueSignals.RECONNECT_ATTEMPTS, reconnect_attempt)
        Logging.Warn(" Internet connection still offline after " + reconnect_attempt + " attempts")
      }else {
        // Check if it was a reconnection to reload channel info and messages
        if (reconnect_attempt > 0) {
            Global.globalValue(VueSignals.CONNECTION_LOST, false);
        }
        reconnect_attempt = -1
      }

      // If the user has internet connection but socket is down
      if(navigator.onLine && socket_closed){
        if(session_id && session_id.length > 0 && session_id != null){
          Socket.init()
          Socket.Notify({"session_id": session_id})
        }
      }
  }

  static heartbeat() {
    if(!block_reconnecting){
      if(logout){
        return
      }
      Socket.reconnectAttempt();
      if(reconnect_attempt <  MAX_CONNECTION_ATTEMPTS ){
        setTimeout(() => Socket.heartbeat()
        , SHORT_HEART_BEATS);
      } else {
         // Ran out of reconnection attempts
         Socket.close();
         setTimeout(() => Socket.heartbeat()
         , LONG_HEART_BEATS);
      }
    }
  }
}
